import React from "react";

import "./errorMessage.styles.scss";

interface ErrorMessageProps {
  text?: string;
}

const ErrorMessage = ({ text }: ErrorMessageProps) => (
  <>
    {text ? (
      <p className="errorMessage">{text}</p>
    ) : (
      <p className="errorMessage">Please enter a valid product number.</p>
    )}
  </>
);

export default ErrorMessage;
